"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { ComboboxChevron, ComboboxDropdown, ComboboxDropdownTarget, ComboboxEmpty, ComboboxEventsTarget, ComboboxFooter, ComboboxGroup, ComboboxHeader, ComboboxOption, ComboboxOptions, ComboboxSearch, ComboboxTarget, Combobox as MantineCombobox, factory, useCombobox, useProps, } from "@mantine/core";
import "@mantine/core/styles/Combobox.layer.css";
import "@mantine/core/styles/Popover.layer.css";
import * as styles from "./Combobox.module.css";
const Combobox = factory((props, 
// `Combobox` currently does not accept a `ref` prop
_ref) => {
    const modifiedProps = useProps("Combobox", {
        classNames: styles,
    }, props);
    return _jsx(MantineCombobox, { ...modifiedProps });
});
Combobox.displayName = "Combobox";
ComboboxChevron.displayName = "ComboboxChevron";
ComboboxDropdown.displayName = "ComboboxDropdown";
ComboboxDropdownTarget.displayName = "ComboboxDropdownTarget";
ComboboxEmpty.displayName = "ComboboxEmpty";
ComboboxEventsTarget.displayName = "ComboboxEventsTarget";
ComboboxFooter.displayName = "ComboboxFooter";
ComboboxGroup.displayName = "ComboboxGroup";
ComboboxHeader.displayName = "ComboboxHeader";
ComboboxOption.displayName = "ComboboxOption";
ComboboxOptions.displayName = "ComboboxOptions";
ComboboxSearch.displayName = "ComboboxSearch";
ComboboxTarget.displayName = "ComboboxTarget";
Combobox.Chevron = ComboboxChevron;
Combobox.Dropdown = ComboboxDropdown;
Combobox.DropdownTarget = ComboboxDropdownTarget;
Combobox.Empty = ComboboxEmpty;
Combobox.EventsTarget = ComboboxEventsTarget;
Combobox.Footer = ComboboxFooter;
Combobox.Group = ComboboxGroup;
Combobox.Header = ComboboxHeader;
Combobox.Option = ComboboxOption;
Combobox.Options = ComboboxOptions;
Combobox.Search = ComboboxSearch;
Combobox.Target = ComboboxTarget;
export { Combobox, useCombobox, };
//# sourceMappingURL=Combobox.js.map